import React, { useCallback, useRef } from 'react';
import {
  openErrorToaster,
  openSuccessToaster,
} from 'services/toast.service';
import styles from './CopyableBlockquote.module.scss';

type CopyableBlockquoteProps = {
  children?: React.ReactNode;
  className?: string;
};

export default function CopyableBlockquote({
  children,
  className,
}: CopyableBlockquoteProps) {
  const ref = useRef<HTMLQuoteElement>(null);

  const handleCopy = useCallback(async () => {
    const text = ref.current?.innerText?.trim() ?? '';
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      openSuccessToaster('Copied to clipboard.', 2000);
    } catch {
      openErrorToaster('Could not copy text.', 3000);
    }
  }, []);

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={styles.copyBtn}
        onClick={() => {
          handleCopy().catch(() => undefined);
        }}
        aria-label="Copy blockquote"
        title="Copy"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
        </svg>
      </button>
      <blockquote
        ref={ref}
        className={[styles.blockquote, className]
          .filter(Boolean)
          .join(' ')}
      >
        {children}
      </blockquote>
    </div>
  );
}
